import { ROUTE_PATH } from 'src/routes/route.constant';
import { useProfileStore } from 'src/store/profile/useProfileStore';

export const usePermission = () => {
  const { profile } = useProfileStore();

  return {
    isTeacher: profile?.role === 'TEACHER',
    isFormTeacher: profile?.role === 'FORM_TEACHER',
    isSchoolManager: profile?.role === 'SCHOOL_MANAGER',
    isAdminApp: profile?.role === 'ADMIN_APP',
    isAdminNational: profile?.role === 'ADMIN_NATIONAL',
  };
};

// [NEW 2026-06-30] - Role-based default landing page used after login and on app startup ("/").
// Source of truth for these mappings is the product spec supplied by the user on 2026-06-30:
//   - 講師 (TEACHER)         → /user-management
//   - 担任 (FORM_TEACHER)    → /user-management
//   - 各校担当 (SCHOOL_MANAGER) → /user-management
//   - 全国統括 (ADMIN_NATIONAL) → /school-management
//   - ADMIN_APP              → /question-management (historic default; not specified)
//
export const ROLE_DEFAULT_LANDING_PATH: Record<string, string> = {
  TEACHER: ROUTE_PATH.USER_MANAGEMENT,
  FORM_TEACHER: ROUTE_PATH.USER_MANAGEMENT,
  SCHOOL_MANAGER: ROUTE_PATH.USER_MANAGEMENT,
  ADMIN_NATIONAL: ROUTE_PATH.SCHOOL_MANAGEMENT,
  ADMIN_APP: ROUTE_PATH.SCHOOL_MANAGEMENT,
};

export const DEFAULT_LANDING_PATH = ROUTE_PATH.QUESTION_MANAGEMENT;

export const getDefaultLandingPath = (role?: string): string => {
  if (role && ROLE_DEFAULT_LANDING_PATH[role]) {
    return ROLE_DEFAULT_LANDING_PATH[role];
  }
  return DEFAULT_LANDING_PATH;
};
